import { render, staticRenderFns } from "./SignupTryoutData.vue?vue&type=template&id=06b4fd48&"
import script from "./SignupTryoutData.vue?vue&type=script&lang=js&"
export * from "./SignupTryoutData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports